import NotFound from './notFound'

export {NotFound}

export default NotFound
